import {UserGroup} from '../model';
import {Permissions, rolePermissions} from './permissions';

export const isAuthorized = (
  currentUserGroups: UserGroup[],
  permission: Permissions
): boolean => {
  const allowed: Permissions[] = [permission, 'FULL_ACCESS'];

  return currentUserGroups.some(group => {
    const permissions = rolePermissions[group];
    return (
      permissions?.length && allowed.some(value => permissions.includes(value))
    );
  });
};

export const isAuthorizedGroups = (
  currentUserGroups: UserGroup[],
  allowedGroups: UserGroup[]
) => {
  return currentUserGroups.some(group => allowedGroups.includes(group));
};

export const passwordGroups = [
  UserGroup.Superusers,
  UserGroup.Owners,
  UserGroup.Admins,
  UserGroup.Moderators,
  UserGroup.EmployeesInventory,
];

export const isPasswordGroup = (groups: UserGroup[]): boolean => {
  return isAuthorizedGroups(groups, passwordGroups);
};

export const technicalGroups = [UserGroup.Superusers, UserGroup.Owners];

export const isTechnicalGroup = (groups: UserGroup[]): boolean => {
  return isAuthorizedGroups(groups, technicalGroups);
};

export const uiManagedGroups = [
  UserGroup.Admins,
  UserGroup.Moderators,
  UserGroup.EmployeesInventory,
  UserGroup.Employees,
];

export const isUiManagedGroupGroup = (groups: UserGroup[]): boolean => {
  return isAuthorizedGroups(groups, uiManagedGroups);
};

export const getAuthorizedGroups = (permission: Permissions): UserGroup[] => {
  const allowed: Permissions[] = [permission, 'FULL_ACCESS'];

  return Object.entries(rolePermissions).reduce<UserGroup[]>(
    (acc, [group, permissions]) => {
      if (permissions.length && allowed.some(p => permissions.includes(p))) {
        acc.push(group as UserGroup);
      }
      return acc;
    },
    []
  );
};
